import './App.css'

// 当前版本：1.4.2.231104
//author : syh uestc

import {
  Login,
  RequireAuth,
  Homepage,
  UserManage,
  SwiperManage,
  HouseManage,
  EventManage,
  PostManage,
  StudyManage,
  RentManage,
  BeforeTravelManage,
  CommentManage,
  PostDetail,
  NewHouse,
  NewContent,
  MemberManage,
  SecondHand,
  FallGroup,
  RentReadMe,
  NewSecondHand,
  EditRentReadMe,
} from './pages'
import { Routes, Navigate, Router, Route } from 'react-router-dom'
import detectZoom from './utils/zoom'
import UnAuthority from './components/unAuthority/unAuthority'

function App() {
  // const m = detectZoom()

  // document.body.style.zoom = 100 / Number(m)
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<RequireAuth></RequireAuth>}>
          <Route path="/homepage" element={<Homepage />}></Route>
          <Route path="/userManage" element={<UserManage />}></Route>
          <Route path="/swiperManage" element={<SwiperManage />}></Route>

          <Route path="/houseManage" element={<HouseManage />}></Route>
          <Route path="/newHouse" element={<NewHouse />}></Route>
          <Route path="/eventManage" element={<EventManage />}></Route>
          <Route path="/postManage" element={<PostManage />}></Route>
          <Route path="/postDetail" element={<PostDetail />}></Route>

          <Route path="/commentManage" element={<CommentManage />}></Route>
          <Route path="/studyManage" element={<StudyManage />}></Route>
          <Route path="/rentManage" element={<RentManage />}></Route>
          <Route
            path="/beforeTravelManage"
            element={<BeforeTravelManage />}
          ></Route>
          <Route path="/newContent" element={<NewContent />}></Route>

          <Route path="/memberManage" element={<MemberManage />}></Route>

          <Route path="/secondHand" element={<SecondHand />}></Route>

          <Route path="/fallGroup" element={<FallGroup />}></Route>

          <Route path="/rentReadme" element={<RentReadMe />}></Route>

          <Route path="/newSecondHand" element={<NewSecondHand />}></Route>

          <Route path="/editRentReadMe" element={<EditRentReadMe />}></Route>
        </Route>

        <Route path="/login" element={<Login />}></Route>
        <Route path="/403" element={<UnAuthority />}></Route>
      </Routes>
    </div>
  )
}

export default App
